import React from 'react';
import { useIntl } from 'react-intl-next';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { blockTypeMessages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import QuotationMarkIcon from '@atlaskit/icon/core/quotation-mark';
import { BLOCK_QUOTE } from './consts';
var QuoteBlockMenuItem = function QuoteBlockMenuItem(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var currentBlockType = useSharedPluginStateSelector(api, 'blockType.currentBlockType');
  var isBlockQuote = currentBlockType && currentBlockType === BLOCK_QUOTE;
  var handleClick = function handleClick(event) {
    if (!isBlockQuote) {
      var _api$blockMenu;
      var triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? INPUT_METHOD.KEYBOARD : INPUT_METHOD.MOUSE;
      var inputMethod = INPUT_METHOD.BLOCK_MENU;
      api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.formatNode("blockquote", {
        inputMethod: inputMethod,
        triggeredFrom: triggeredFrom
      }));
    }
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    onClick: handleClick,
    isSelected: isBlockQuote,
    elemBefore: /*#__PURE__*/React.createElement(QuotationMarkIcon, {
      label: ""
    })
  }, formatMessage(blockTypeMessages.blockquote));
};
export var createQuoteBlockMenuItem = function createQuoteBlockMenuItem(_ref2) {
  var api = _ref2.api;
  return function () {
    return /*#__PURE__*/React.createElement(QuoteBlockMenuItem, {
      api: api
    });
  };
};